import script from "./PaymentMethods.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentMethods.vue?vue&type=script&setup=true&lang=js"

import "./PaymentMethods.vue?vue&type=style&index=0&id=1bec0930&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bec0930"]])

export default __exports__